module.exports = __webpack_public_path__ + "img/1728542531217-WhatsApp Image 2024-10-10 at 14.32.03.jpeg.6ca6c3b1.webp";